<template>
    <v-card
        class="bg-grey"
        flat
        @drop="handleFileDrop"
        id="exportForm"
    >
        <v-card-title v-if="files.length" class="mt-n8">
            <v-spacer></v-spacer>
            <v-icon class="d-flex align-self-center mx-2" large @click="save()" color="success">mdi-content-save</v-icon>
            <v-icon class="d-flex align-self-center mx-2" large @click="clean()" color="red">mdi-delete</v-icon>
        </v-card-title>

        <v-container fluid fill-height>
            <v-row v-if="files.length == 0">
                <v-col cols="12" align="center">
                    <v-icon size="100"> {{ icon }} </v-icon>
                    <div class="overline font-weight-light">
                        Arrastre el archivo o haga click para abrir el explorador de archivos
                    </div>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col
                    cols="12"
                    class="d-flex justify-center"
                >
                    <v-badge class="mt-n12" color="error" icon="mdi-arrow-up-bold" overlap>
                        <v-icon color="green accent-1" size="100">
                            mdi-image
                        </v-icon>
                        <div class="mt-n16 absolute overline">
                            <small>{{ files[0].name.slice(0, 15) }}</small>
                        </div>
                        <div class="mt-n4 absolute grey--text overline">
                            {{ (files[0].size / (1024 * 1024)).toFixed(1) }} MB
                        </div>
                    </v-badge>
                </v-col>
            </v-row>
        </v-container>

        <input
            v-if="!files.length"
            type="file"
            name="file-input"
            @change="handleFileInput"
        />
    </v-card>
</template>

<script>

export default {
    data: () => ({
        files: [],
    }),
    props: {
        action: null,
        paramName: null,
        allowedExtensions: [],
        icon: null, 
        extra_params: {},
    },
    methods: {
        clean(){
            this.files = [];
        },
        save(){
            let upload = {}
            upload[this.paramName] = this.files[0];
            upload = {...upload, ...this.extra_params}
            this.$store.dispatch(this.action, upload);
            this.clean();
        },
        handleFileDrop(e) {
            let droppedFiles = e.dataTransfer.files;
            let fileExtention = droppedFiles[0].name.split('.').pop();

            if (!droppedFiles) return;
            else {
                this.files = [];

                    if (this.allowedExtensions.includes(fileExtention)) {
                        this.files.push(droppedFiles[0]);
                    } else {
                        this.$store.dispatch(
                            'util/showStatusSnackBar',
                            {
                                statusType: 'error',
                                message:
                                    'El archivo ' +
                                    droppedFiles[0].name +
                                    ' no es del tipo correcto',
                            },
                            { root: true }
                        );
                    }
            }
        },
        handleFileInput(e) {
            let files = e.target.files;
            let fileExtention = files[0].name.split('.').pop();

            if (!files) return;
            else {
                this.files = [];

                if (this.allowedExtensions.includes(fileExtention)) {
                    this.files.push(files[0]);
                } else {
                    this.$store.dispatch(
                        'util/showStatusSnackBar',
                        {
                            statusType: 'error',
                            message:
                                'El archivo ' +
                                files[0].name +
                                ' no es del tipo correcto',
                        },
                        { root: true }
                    );
                }
            }
        },
    },
    computed: {
    },
}
</script>

<style scoped>
.absolute {
    position: absolute;
}

#exportForm{
    margin-top: 5%;
    margin-bottom: 12%;
}

#exportForm input {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -10%;
    margin-left: -50%;
    width: 100%;
    height: 200px;
    opacity: 0;
    cursor: pointer;
}

.bg-grey {
    background-color: #f5f5f5;
    border-radius: 10px;
}

@media screen and (max-width: 600px) {
    #exportForm {
        margin-top: 15%;
        margin-bottom: 20%;
    }

    #exportForm input {
        margin-top: -30%;
    }
}
</style>